import * as React from 'react';
import { cn } from '../../utils/cn';
import { type VariantProps } from 'class-variance-authority';
import { clearButtonVariants } from './styles';
import { XIcon } from '../icons/X';

export interface ClearButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof clearButtonVariants> {
  /**
   * Function called when the button is clicked
   */
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /**
   * ID for testing
   */
  dataTestId?: string;
}

/**
 * ClearButton Component
 *
 * A simple button for clearing or removing content, displayed as an X icon.
 */
export const ClearButton = React.forwardRef<
  HTMLButtonElement,
  ClearButtonProps
>(({ onClick, className, dataTestId = 'clear-button', ...props }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={cn(clearButtonVariants(), className)}
      onClick={(e) => onClick?.(e)}
      data-testid={dataTestId}
      aria-label="Clear"
      {...props}>
      <XIcon className="w-[10px] h-[10px] text-clear-button-icon" />
    </button>
  );
});

ClearButton.displayName = 'ClearButton';
